import styled from 'styled-components';

export const GridBody = styled.div`
  box-sizing: border-box;
  width: 100%;
  display: grid;
  grid-gap: 5px;
  grid-template-columns: auto auto auto;

  ${(props) => props.theme.breakpoints.down('sm')} {
    grid-template-columns: auto auto;
  }
`;
